import posthog from "posthog-js";

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";
  if (!key) {
    // eslint-disable-next-line no-console
    console.info("[analytics] PostHog key not set; analytics disabled.");
    return;
  }
  posthog.init(key, {
    api_host: host,
    capture_pageview: "history_change",
    capture_pageleave: true,
    autocapture: true,
    persistence: "localStorage+cookie",
    person_profiles: "identified_only",
    enable_heatmaps: true,
    capture_performance: true,
    scroll_root_selector: ["html", "body"],
  });
  initialized = true;
}

export function trackPageview(path) {
  if (!initialized) return;
  if (typeof window !== "undefined") {
    posthog.capture("$pageview", { path });
  }
}

export function track(event, properties) {
  if (!initialized) return;
  try {
    posthog.capture(event, properties || {});
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[analytics] capture failed", event, err);
  }
}

export default posthog;
